import _slicedToArray from "/root/website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';

function useInputBoxed(_ref) {
  var value = _ref.value,
      disabled = _ref.disabled,
      autoFocus = _ref.autoFocus,
      placeholder = _ref.placeholder,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus;
  var inputRef = React.useRef();

  var _React$useState = React.useState(Boolean(value)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      active = _React$useState2[0],
      setActive = _React$useState2[1];

  var _React$useState3 = React.useState(Boolean(autoFocus && !disabled)),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      focused = _React$useState4[0],
      setFocused = _React$useState4[1];

  React.useEffect(function () {
    if (!value && !autoFocus) {
      setActive(false);
    }
  }, [value, autoFocus]);
  React.useEffect(function () {
    if (value && !active || placeholder) {
      setActive(true);
    }
  }, [value, placeholder, active]);

  var setFocus = function setFocus() {
    var _inputRef$current;

    setFocused(true);
    (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.focus();
  };

  var handleOnBlur = function handleOnBlur(event) {
    setFocused(false);

    if (!event.target.value) {
      setActive(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  var handleOnFocus = function handleOnFocus(event) {
    setFocused(true);
    setActive(true);

    if (onFocus) {
      onFocus(event);
    }
  };

  var handleOnClick = function handleOnClick(event) {
    if (disabled) {
      event.stopPropagation();
      return;
    }

    setFocus();
    setActive(true);
  };

  return {
    active: active,
    focused: focused,
    inputRef: inputRef,
    handleOnBlur: handleOnBlur,
    handleOnFocus: handleOnFocus,
    handleOnClick: handleOnClick
  };
}

export { useInputBoxed };